import { z } from "zod";
import { runEffortSchema, runModelTierSchema } from "./runs";

export const notificationChannels = ["off", "in-app", "in-app-and-email"] as const;
export const notificationChannelSchema = z.enum(notificationChannels);
export type NotificationChannel = z.infer<typeof notificationChannelSchema>;

export const notificationEvents = [
  "run-finished",
  "run-waiting-approval",
  "approval-decided",
  "credits-low",
  "grant-expiring",
  "member-invited",
] as const;
export const notificationEventSchema = z.enum(notificationEvents);
export type NotificationEvent = z.infer<typeof notificationEventSchema>;

export const projectSettingsSchema = z.object({
  projectId: z.uuid(),
  name: z.string().min(1),
  slug: z.string().min(1),
  description: z.string().nullable(),
  timeZone: z.string().min(1),
  defaultModelTier: runModelTierSchema,
  defaultEffort: runEffortSchema,
  perRunCap: z.number().int().min(1),
  concurrentRunLimit: z.number().int().min(1),
  status: z.enum(["active", "archived"]),
  /** When true, adding a scope to a connection requires approval. */
  scopeApprovalRequired: z.boolean(),
});
export type ProjectSettings = z.infer<typeof projectSettingsSchema>;

export const updateProjectSettingsSchema = z.object({
  name: z.string().trim().min(1).max(120),
  description: z.string().trim().max(500).nullable().optional(),
  timeZone: z.string().trim().min(1).max(80),
  defaultModelTier: runModelTierSchema,
  defaultEffort: runEffortSchema,
  perRunCap: z.number().int().min(1),
  concurrentRunLimit: z.number().int().min(1),
  /** When true, adding a scope to a connection requires approval. */
  scopeApprovalRequired: z.boolean().optional(),
});
export type UpdateProjectSettings = z.infer<typeof updateProjectSettingsSchema>;

export const notificationPreferenceSchema = z.object({
  event: notificationEventSchema,
  channel: notificationChannelSchema,
});
export type NotificationPreference = z.infer<typeof notificationPreferenceSchema>;

export const notificationPreferenceListSchema = z.array(notificationPreferenceSchema);
export type NotificationPreferenceList = z.infer<typeof notificationPreferenceListSchema>;

export const updateNotificationsSchema = z.object({
  preferences: z.array(notificationPreferenceSchema).min(1),
});
export type UpdateNotifications = z.infer<typeof updateNotificationsSchema>;
